import { render, staticRenderFns } from "./BusinessProfileTinsControl.vue?vue&type=template&id=9ea53534&"
import script from "./BusinessProfileTinsControl.vue?vue&type=script&lang=js&"
export * from "./BusinessProfileTinsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports